import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import Button from '@mui/material/Button';
import EligibilityClose from './EligibilityClose';
import EligibilityIframe from './EligibilityIframe';
import PortalInfo from './PortalInfo';
import EligibilityAgentModalContainer from './EligibilityAgentModal/EligibilityAgentModal.container';
import EligibilityAgentViewContainer from './EligibilityAgentView/EligibilityAgentView.container';
import { theme } from '../../theme';
import ExpandMoreIcon from '../common/icons/expandmore';

class EligibilityFrame extends React.Component {
  handleCloseErrorModal() {
    this.props.closeErrorModal();
  }

  render() {
    const top = this.props.portalInfo ? 247 : 47;

    return (
      <div>
        <EligibilityClose isLoading={this.props.isLoading} />
        <PortalInfo isLoading={this.props.isLoading} />
        <EligibilityIframe top={top} />
        <Dialog
          open={!!this.props.errorMessage}
          onClose={() => this.handleCloseErrorModal()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="alert-dialog-title">Eligibility Check Failed</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" component="div" sx={{ color: theme.palette.primary.dark }}>
              {this.props.errorMessage}
            </DialogContentText>
            {this.props.errorDetails && (
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                sx={{
                  mt: 2,
                  boxShadow: 'none',
                  border: '1px solid rgba(13, 43, 89, 0.16)',
                  '&:before': { display: 'none' },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="eligibility-error-details"
                  id="eligibility-error-details-header"
                  sx={{
                    height: 48,
                    minHeight: 48,
                    '&.Mui-expanded': {
                      height: 48,
                      minHeight: 48,
                    },
                    '& .MuiAccordionSummary-content': {
                      my: 1,
                    },
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                      my: 1,
                    },
                  }}
                >
                  <Box component="span" sx={{ color: theme.palette.primary.dark, fontSize: 14, fontWeight: 500 }}>
                    Show full error
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ borderTop: '1px solid rgba(13, 43, 89, 0.12)', p: 2 }}>
                  <Box
                    component="pre"
                    sx={{
                      m: 0,
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      fontFamily: 'monospace',
                      fontSize: 12,
                      color: theme.palette.primary.dark,
                    }}
                  >
                    {this.props.errorDetails}
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleCloseErrorModal()}
              color="primary"
              autoFocus
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(30, 192, 217, 0.1)',
                },
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <EligibilityAgentModalContainer />
        <EligibilityAgentViewContainer />
      </div>
    );
  }
}

EligibilityFrame.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  errorDetails: PropTypes.string.isRequired,
  closeErrorModal: PropTypes.func.isRequired,
  portalInfo: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default EligibilityFrame;
